import API from "./API";
import axios from "axios";

export const Signature = {

    async get(id){
        const url = API.url(`/signatures/${id}`);
        return await axios.get(url);
    },

    async post(data){
        const url = API.url('/signatures');
        return await axios.post(url, data);
    },

    async accept(data){
        const url = API.url(`/signatures/${data.id}/accept`);
        return await axios.put(url, data);
    },

    async verify(data){
        const url = API.url(`/signatures/${data.id}/verify`);
        return await axios.put(url, data);
    },

    async sign(data){
        const url = API.url(`/signatures/${data.id}/sign`);
        return await axios.put(url, data);
    },

}

export default Signature;